const TOP_AND_BOTTOM_SIDE_UNIT = 2;
function getComputedVerticalCollisionPadding(params) {
  const { collisionPadding, fallbackCollisionPadding } = params;
  if (collisionPadding === void 0) {
    return fallbackCollisionPadding * TOP_AND_BOTTOM_SIDE_UNIT;
  }
  if (typeof collisionPadding === "number") {
    return collisionPadding * TOP_AND_BOTTOM_SIDE_UNIT;
  }
  const { top = fallbackCollisionPadding, bottom = fallbackCollisionPadding } = collisionPadding;
  return top + bottom;
}

export { getComputedVerticalCollisionPadding };
//# sourceMappingURL=collision-padding.mjs.map
